import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES} from '../../../constants/typography';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName, IconName} from '../../atoms/Icon/IconName';
import {Text} from '../../atoms/Text/Text';

export const SizeAdvice: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  label: string;
  labelColor?: keyof typeof COLORS;
  iconName?: IconName;
  fill?: keyof typeof COLORS;
  backgroundColor?: keyof typeof COLORS;
}> = ({backgroundColor, fill, iconName, label, labelColor, ...props}) => {
  return (
    <SizeAdviceWrapper {...props} $backgroundColor={backgroundColor}>
      <StyledIcon
        asset={iconName ?? GenericIconName.Ruler}
        fill={fill ?? COLORS.Grey1}
        color={fill ?? COLORS.Grey1}
      />
      <Text color={labelColor ?? 'Grey1'} size="px12" weight="mediumBold">
        {label}
      </Text>
    </SizeAdviceWrapper>
  );
};

const SizeAdviceWrapper = styled.div<{$backgroundColor?: keyof typeof COLORS}>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 1rem;
  background-color: ${({$backgroundColor}) =>
    $backgroundColor ? COLORS[$backgroundColor] : 'unset'};
`;

const StyledIcon = styled(Icon)`
  width: ${FONT_SIZES.px20};
  height: ${FONT_SIZES.px20};
  margin-right: 0.625rem;
`;
